import { render, staticRenderFns } from "./VacanciesContainer.vue?vue&type=template&id=d5a010a4&scoped=true"
import script from "./VacanciesContainer.vue?vue&type=script&lang=js"
export * from "./VacanciesContainer.vue?vue&type=script&lang=js"
import style0 from "./VacanciesContainer.vue?vue&type=style&index=0&id=d5a010a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a010a4",
  null
  
)

export default component.exports